import SelectInputBoxWithGroups from './SelectInputBoxWithGroups';

export default SelectInputBoxWithGroups;
